import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, MapPin, Phone } from 'lucide-react';
import { trackOutboundLink } from '../utils/analytics';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0d1b2e] text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/logo-transparent.png" 
                alt="Downes Engineering and Consulting" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Engineering-led advisory services for the built environment. Supporting developers and investors from concept to exit.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#4a9ece] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#4a9ece] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-[#4a9ece] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/how-we-work" className="text-sm hover:text-[#4a9ece] transition-colors">
                  How We Work
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#4a9ece] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-white mb-4">Get in Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#4a9ece] mt-0.5 flex-shrink-0" />
                <span className="text-sm">Ireland</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[#4a9ece] mt-0.5 flex-shrink-0" />
                <a 
                  href="mailto:Ciaran@downesengineering.com" 
                  onClick={() => trackOutboundLink('email', 'Ciaran@downesengineering.com', 'downesengineering.com')}
                  className="text-sm hover:text-[#4a9ece] transition-colors"
                >
                  Ciaran@downesengineering.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Linkedin size={18} className="text-[#4a9ece] mt-0.5 flex-shrink-0" />
                <a 
                  href="https://www.linkedin.com/company/downes-engineering-consulting" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  onClick={() => trackOutboundLink('linkedin', 'Company Profile', 'linkedin.com')}
                  className="text-sm hover:text-[#4a9ece] transition-colors"
                >
                  Connect on LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-10 pt-8 text-center">
          <p className="text-sm text-slate-500">
            &copy; {currentYear} Downes Engineering and Consulting. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
